<script>
import { fabric } from 'fabric';
import ImageBoxTool from './ImageBoxTool';

import { NORMAL_SIZE } from './TextSizeBoxTool';

export const DEFAULT_TEXT = 'Add text here';

export default {
  name: 'AddTextImageBoxTool',
  extends: ImageBoxTool,
  data() {
    return {
      icon: 'font',
      title: 'Add Text',
      normal_size: NORMAL_SIZE,
      hotkey: 'alt+t',
    };
  },
  methods: {
    action() {
      this.addText();
    },
    addText(text = null) {
      const content = (text) || DEFAULT_TEXT;
      const textbox = new fabric.Textbox(content, {
        originX: 'center',
        originY: 'center',
        width: 150,
        left: Math.floor(Math.random() * 200) + 50,
        top: Math.floor(Math.random() * 300) + 50,
        fill: this.$store.state.preferences.color,
        strokeWidth: 0,
        stroke: '#880E4F',
        fontFamily: this.parent.font,
        fontSize: this.normal_size,
        lockUniScaling: true,
        borderColor: '#007BFF',
        cornerColor: '#007BFF',
        cornerSize: 6,
      });

      this.canvas.on('text:changed', (opt) => {
        // eslint-disable-next-line no-shadow
        const textbox = opt.target;
        const textLength = textbox.text;

        if (textLength.length > textbox.width) {
          textbox.width = (textLength.length);
          this.canvas.renderAll();
        }
      });
      this.canvas.add(textbox);
      textbox.setControlsVisibility({
        mt: false, // middle top disable
        mb: false, // midle bottom
      });
      // itext.enterEditing();
      this.$emit('textSelected', textbox);
    },
  },
};
</script>
